import { setupAPIClient } from './apiClient';

export const api = setupAPIClient();
